export const TheViewerVideoProps = {
  id: String,
  previewFileInfo: Object,
}

export const speedList = [
  {
    name: '0.5x',
    value: 0.5,
    type: '',
  },
  {
    name: '0.75x',
    value: 0.75,
    type: '',
  },
  {
    name: '1.0x',
    value: 1.0,
    type: '',
  },
  {
    name: '1.25x',
    value: 1.25,
    type: 'vip',
  },
  {
    name: '1.5x',
    value: 1.5,
    type: 'vip',
  },
  {
    name: '1.75x',
    value: 1.75,
    type: 'vip',
  }, {
    name: '2.0x',
    value: 2.0,
    type: 'vip',
  },
]

export const speedMap = {
  0.5: 'half',
  0.75: 'three_four',
  '1.0': 'normal',
  1.25: 'five_four',
  1.5: 'third_two',
  1.75: 'seven_four',
  '2.0': 'twice',
}

export const TheViewerVideoInitData = {
  playUrl: '',
  isPlay: false,
  isPause: false,
  defaultCover: require('@remote/assets/images/default_cover.png'),
  isPlayend: false,
  isMuted: false,
  videoVolume: 100,
  videoVolumeCp: 100,
  videoProgress: 0,
  videoCurTime: '00:00:00',
  videoDuration: '00:00:00',
  // 试看时长ms，两分钟
  tryDuration: 2 * 60 * 1000,
  startTime: 0,
  tryStart: 0,
  speedList: speedList.reverse(),
  isVideoEventsInit: false,
  isPlayFull: false,
  showSpeedTip: false,
  curSpeed: '1.0',
  isPlayFail: false,
  showControl: true,
  usefulMedias: [],
  usefulMedia: {},
  speedTxt: '',
  isPlayStart: false,
  isSeek: false,
  isSeeking: false,
  isHidden: false,
  hiddenStart: 0,
  cacheBuffer: {
    left: 0,
    width: 0,
  },
  videoScale: 1,
  isPlayerInited: false,
  isPlayerParsing: false,
  qrcode: require('@remote/assets/images/web/qrcode.png'),
  isBrowserVideo: false,
  isDPlayerVideo: false,
  isPictureinpicture: false,
  autoFail: false,
}